import { useEffect } from 'react';
import { buildStockAlertText } from '../../utils/productStock.js';

/**
 * Modal ao tentar adicionar quantidade acima do stock disponível.
 *
 * @param {{
 *   open: boolean,
 *   productName?: string,
 *   available?: number,
 *   onClose: () => void,
 * }} props
 */
export function StockLimitModal({ open, productName = '', available = 0, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    function onKey(e) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const { title, body } = buildStockAlertText(productName, available);
  const nome = String(productName || '').trim();

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/55 p-4 backdrop-blur-[2px]"
      onClick={onClose}
      role="presentation"
    >
      <div
        role="alertdialog"
        aria-labelledby="stock-limit-title"
        aria-describedby="stock-limit-body"
        className="w-full max-w-sm rounded-2xl border border-zinc-200 bg-white p-5 shadow-2xl dark:border-zinc-700 dark:bg-zinc-900"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="stock-limit-title" className="font-display text-lg font-semibold text-zinc-900 dark:text-zinc-50">
          {title}
        </h3>
        {nome ? (
          <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-zinc-500 dark:text-zinc-400">
            {nome}
          </p>
        ) : null}
        <p id="stock-limit-body" className="mt-3 text-sm leading-relaxed text-zinc-700 dark:text-zinc-200">
          {body}
        </p>
        <button
          type="button"
          onClick={onClose}
          className="mt-5 w-full rounded-xl bg-[var(--st-600)] px-4 py-3 text-sm font-bold uppercase tracking-wide text-white transition hover:bg-[var(--st-500)] dark:bg-[var(--st-500)] dark:hover:bg-[var(--st-400)]"
        >
          Entendi
        </button>
      </div>
    </div>
  );
}
